/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import { AppServiceSyncMachineConfig } from '../../state-machine';
import {
  triggerRiskCapitalPremium,
  triggerParametroPlatformCharge,
  triggerInsuranceProviderCharge,
  triggerTotalPremium,
} from './states';
import uuid from 'react-uuid';

export const PREMIUM_CALCULATOR_CONFIG: AppServiceSyncMachineConfig = {
  init: 'START',
  transitions: [
    {
      name: 'triggerParametroPlatformCharge',
      from: 'START',
      to: 'PARAMETRO_PLATFORM_CHARGE',
    },
    {
      name: 'triggerInsuranceProviderCharge',
      from: 'PARAMETRO_PLATFORM_CHARGE',
      to: 'INSURANCE_PROVIDER_CHARGE',
    },
    {
      name: 'triggerRiskCapitalPremium',
      from: 'INSURANCE_PROVIDER_CHARGE',
      to: 'RISK_CAPITAL_PREMIUM',
    },
    {
      name: 'triggerTotalPremium',
      from: 'RISK_CAPITAL_PREMIUM',
      to: 'TOTAL_PREMIUM',
    },
    {
      name: 'triggerEnd',
      from: 'TOTAL_PREMIUM',
      to: 'END',
    },
  ],
  methods: {
    onTriggerParametroPlatformCharge: triggerParametroPlatformCharge,
    onTriggerInsuranceProviderCharge: triggerInsuranceProviderCharge,
    onTriggerRiskCapitalPremium: triggerRiskCapitalPremium,
    onTriggerTotalPremium: triggerTotalPremium,
  },
};
